import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

export default function Manifesto() {
  const { manifesto: MANIFESTO, lang } = useLang();
  return (
    <section
      data-testid="manifesto"
      className="relative border-t border-border bg-background"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-24 md:py-40">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-32">
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
                [ {lang === "fr" ? "Chapitre · Manifeste" : "Chapter · The Manifesto"} ]
              </div>
              <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tighter leading-[1] mb-6">
                {lang === "fr" ? "Notre " : "Our "}<i className="text-primary">{lang === "fr" ? "doctrine" : "Doctrine"}</i>
              </h2>
              <p className="text-foreground/70 max-w-sm leading-relaxed">
                {lang === "fr"
                  ? "Quatre principes régissent chaque déploiement que nous effectuons au Nouveau-Brunswick. Ils sont non négociables."
                  : "Four principles govern every deployment we make across New Brunswick. They are non-negotiable."}
              </p>
            </div>
          </div>

          <div className="md:col-span-8 space-y-24 md:space-y-40">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.number}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
                className="relative border-t border-border pt-10"
                data-testid={`manifesto-chapter-${m.number}`}
              >
                <div className="flex items-start gap-8 md:gap-12">
                  <div
                    className="font-serif font-light leading-none text-stroke-muted"
                    style={{ fontSize: "clamp(5rem, 12vw, 12rem)" }}
                  >
                    {m.number}
                  </div>
                  <div className="pt-4 flex-1">
                    <h3 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight mb-6">
                      {m.title}
                    </h3>
                    <p className="text-base md:text-lg text-foreground/80 leading-relaxed max-w-2xl">
                      {m.body}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
